import { CoreApiResponse } from "../../libs/core-api-requests/common";
import {
    IErrorResponseMarketingBonusCalculationCompanyStatus,
    IMarketingBonusCalculationAllCompaniesDTO,
    IMarketingBonusCalculationAllCompaniesStatusDTO,
    IMarketingBonusCalculationOneCompanyDTO, IMarketingBonusCalculationOneCompanyStatusDTO
} from "../../libs/coreapi-dto/dirs/marketingBonusCalculator";
import CoreApiService from "../../system/api/coreApiService";

export class MarketingBonusCalculatorDataProvider {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }

    calculateAll(
        callback?: (data: IMarketingBonusCalculationAllCompaniesDTO) => void,
        signal?: AbortSignal | null,
        errCallback?: (err: string | any) => void,
        force?: boolean
    ) {
        const params: Record<string, string> = {};
        if (force !== undefined) {
            params.force = String(force);
        }
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.calculateAll(
                    params,
                    (e) => {
                        if (e.respType === 'isCompleted') {
                            callback?.(e.data);
                        } else {
                            errCallback?.({
                                message: e.message?.title || 'Unknown error',
                                detail: e.message?.detail,
                            });
                        }
                    },
                    signal)
            );
    }

    calculateOne(
        idGlobal: string,
        callback?: (data: IMarketingBonusCalculationOneCompanyDTO) => void,
        signal?: AbortSignal | null,
        errCallback?: (err: string | any) => void,
        force?: boolean
    ) {
        const params: Record<string, string> = {};
        if (force !== undefined) {
            params.force = String(force);
        }
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.calculateOne(
                    idGlobal,
                    params,
                    (e: CoreApiResponse<IMarketingBonusCalculationOneCompanyDTO>) => {
                        if (e.respType === 'isCompleted') {
                            callback?.(e.data);
                        } else {
                            errCallback?.({
                                message: e.message?.title || 'Unknown error',
                                detail: e.message?.detail,
                            });
                        }
                    },
                    signal)
            );
    }

    getStatusOne(
        companyId: string,
        callback: (e: IMarketingBonusCalculationOneCompanyStatusDTO) => void,
        errCallback: (err: IErrorResponseMarketingBonusCalculationCompanyStatus) => void,

    ) {
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.getStatusOne(companyId, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback(e.data);
                    } else {
                        errCallback(e.message as IErrorResponseMarketingBonusCalculationCompanyStatus);
                    }

                })
            )
    };

    getStatusAll(
        executionId: string,
        callback: (e: IMarketingBonusCalculationAllCompaniesStatusDTO) => void,
        errCallback: (err: IErrorResponseMarketingBonusCalculationCompanyStatus) => void,
    ) {
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.getStatusAll(executionId, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback(e.data);
                    } else {
                        errCallback(e.message as IErrorResponseMarketingBonusCalculationCompanyStatus);
                    }

                })
            )
    };

    getStatusAllLast(
        callback: (e: IMarketingBonusCalculationAllCompaniesStatusDTO) => void,
        errCallback: (err: IErrorResponseMarketingBonusCalculationCompanyStatus) => void,
    ) {
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.getStatusAllLast((e) => {
                    if (e.respType === 'isCompleted') {
                        callback(e.data);
                    } else {
                        errCallback(e.message as IErrorResponseMarketingBonusCalculationCompanyStatus);
                    }

                })
            )
    };

    getStatusAllByJobId(
        jobId: string,
        callback: (e: IMarketingBonusCalculationAllCompaniesStatusDTO) => void,
        errCallback: (err: IErrorResponseMarketingBonusCalculationCompanyStatus) => void,
    ) {
        this._coreApiService.marketingBonusCalculatorRequest
            .then(r =>
                r.getStatusAllByJobId(jobId, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback(e.data);
                    } else {
                        errCallback(e.message as IErrorResponseMarketingBonusCalculationCompanyStatus);
                    }

                })
            )
    };
}